// extracted by css-extract-rspack-plugin
export default {"negativeTopMargin":"_3d95c61d"};